import storage from "../storage";

export const DiagnosticHook = {
  mounted() {
    this.handleEvent("import_diagnostic", async (data) => {
      try {
        await setDiagnostic(data);
        this.pushEvent("import_success", {});
      } catch (_error) {
        this.pushEvent("import_error", {});
      }
    });
  },
};

async function setDiagnostic(data) {
  const taskId = data.task_id;
  for (const [database, databaseValues] of Object.entries(data.storage_dump)) {
    if (database === "phenix-field") {
      for (const [storeName, storeValues] of Object.entries(databaseValues)) {
        if (storeName === "alpine_persist") {
          await setStoreItems(storeValues, storeName, taskId);
        }
      }
    }
  }
}

async function setStoreItems(storeValues, storeName, taskId) {
  for (const [_key, value] of Object.entries(storeValues)) {
    if (!taskId || (storeName === "alpine_persist" && value.task_id === taskId)) {
      await storage.setItem(value, { storeName: storeName });
    }
  }
}
